import React, { useState, useEffect } from "react";
import { Title, Text } from "rizzui/typography";
import { Button, Input } from "rizzui";
import AccountBox from "../../component/accountBox";
import { useForm } from "react-hook-form";
import { emailValidationPattern } from "./signup";
import { useNavigate } from "react-router";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { baseUrl } from "./login";
import { inputClassName, labelClassName } from "../projects/new/first";

export default function ForgotPassword() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Forgot Password";
  }, []);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const {
    data: success,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ["forgot_password"],
    queryFn: async () => {
      const { email } = getValues();
      return axios
        .post(`${baseUrl}/auth/forgot_password`, {
          email,
        })
        .then((response) => {
          if (response?.data?.message) navigate("/account/linksent");
          return response.data.message ?? false;
        })
        .catch((e) => {
          return Promise.reject(
            new Error(
              e?.response?.data?.message ?? "Something went wrong, try again"
            )
          );
        });
    },
    retry: 0,
    enabled: false,
  });

  const handleForgot = handleSubmit((data) => {
    refetch();
  });

  return (
    <AccountBox>
      <div className="mb-[32px]">
        <Title className="text-[18px] leading-[23.4px] font-[600] text-primary-dark mb-[8px] font-ibmPlexSerif">
          {" "}
          Recover your password{" "}
        </Title>
        <Text className="text-[14px] leading-[18.48px] font-[400] text-secondary-dark font-switzer">
          We’ll send a link to your email to recover your password
        </Text>
      </div>

      <div className="text-secondary-dark font-switzer">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleForgot();
          }}
          noValidate
        >
          <Input
            type="email"
            label="Email Address"
            variant="text"
            rounded="md"
            inputClassName={inputClassName}
            labelClassName={labelClassName}
            className="mb-[16px]"
            {...register("email", {
              ...emailValidationPattern,
            })}
            error={errors.email?.message ? errors.email.message : ""}
          />

          <Button
            variant="solid"
            className="bg-btn rounded-[4px] text-[12px] font-switzer font-[500] w-full mb-[32px]"
            type="submit"
            isLoading={isLoading}
          >
            Recover password
          </Button>
          {isError && (
            <Text className="text-red font-switzer text-[13px] mt-[-28px] mb-[8px]">
              {error?.message}
            </Text>
          )}
        </form>
      </div>

      <Text className="text-center leading-[18.48px] text-[14px] text-secondary-dark font-switzer">
        Remember your password?{" "}
        <a href="login" className="font-semibold underline">
          Log in
        </a>
      </Text>
    </AccountBox>
  );
}
